import React from "react";
import { useSubheader } from "../../../../_metronic/layout";
export const AllTimeLeaderBoard = () => {
  const suhbeader = useSubheader();
  suhbeader.setTitle("All Time Leaderboard");

  return <></>;
};
